import React, {useState} from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';


export default function SearchBox() {

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [searchBox, setSearchBox] = useState(false);
    const navigate = useNavigate();

    async function Search(value)
    {
        if(value.trim() != "")
        {
            setSearch(value)
            const url = `https://docsserver.onrender.com/search/doc/${value}`;

            let res = await Axios.get(url);

            if(res.data.length != 0)
            {
                setData(res.data);
                setSearchBox(true);
            }

            else
            {
                setSearchBox(false);
            }
        }
        else
        {
            setSearch("");
            setSearchBox(false);
        }
    }

    function OpenDocument(id)
    {
        navigate(`/document/${id}`);
    }

    return (
        <div className='relative w-full mr-8'>
            <div className='hidden md:block w-full'>
                <input value = {search} type="text" className='border-2 bg-gray-100 w-full p-2 rounded-md' placeholder = "Search here" onChange={(e) => Search(e.target.value)}></input>
            </div>

            {searchBox?<div className='bg-white shadow-lg w-full h-fit absolute rounded-md cursor-pointer'>
                {data.map((item, index) => {
                    return(
                        <div  onClick={() => OpenDocument(item.urlkey)} key={index} className='hover:bg-slate-200 p-3'>{item.name}</div>
                    )
                })}
            </div>:""}
        </div>
    )
}
